import { useEffect, useState } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { BsFillCaretRightFill } from "react-icons/bs";
import Cookies from "js-cookie";
import Moment from "react-moment";
import { useTranslation } from "react-i18next";
import DefaultImg from "../../assets/Frame.png";
import PleaseWait from "../../Components/Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchJockeyHistory } from "../../redux/getReducer/getJockeyHistory";
import {
  fetchSinglejockey,
  STATUSES,
} from "../../redux/getReducer/getSingleJockey";
import Stats from "../Tabs/JockeyStats.jsx";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import JockeyEntries from "../Tabs/JockeyEntries";
import VideoFrame from "./VideoFrame";
import HorseModal from "./HorseModal";
import RaceModal from "./RaceModal";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import Pagination from "../../pages/Pagination";
import { IoMdPlay } from "react-icons/io";
import ScrollContainer from "react-indiana-drag-scroll";
import NoHistory from "../../Components/Reuseable/NoHistory.jsx";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";

import { getBaseUrl } from "../../service/apiUrl";
const JockeyDetail = (data) => {
  const { t } = useTranslation();
  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => {
    setmodaldatas(data);
    await setShows(true);
  };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const handleHorseCloses = () => setShowHorse(false);
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };
  const [ShowJockey, setShowJockey] = useState(false);
  const [modaldatasJockey, setmodaldatasJockey] = useState();
  const handleJockeyCloses = () => setShowJockey(false);
  const handleShowJockey = (data) => {
    const id = data?._id || data;
    if (id) navigate("/jockey-detail?" + id);
  };

  const navigate = useNavigate();

  let id = data.data.JockeyOnRaceData1
    ? data.data.JockeyOnRaceData1._id
    : data.data._id
    ? data.data._id
    : data.data;
  const { data: JockeyHistory } = useSelector((state) => state.JockeyHistory);
  const { data: singlejockey, status } = useSelector(
    (state) => state.singlejockey
  );

  let totalcountdata = JockeyHistory ? JockeyHistory?.length : "";
  const [postsPerPage] = useState(11);
  const totalpagesdata = Math.ceil(totalcountdata / postsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const firstPageIndex = (currentPage - 1) * postsPerPage;
  const lastPageIndex = firstPageIndex + postsPerPage;
  const SliceData = JockeyHistory ? JockeyHistory.slice(firstPageIndex, lastPageIndex) : [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const dispatch = useDispatch();

  const handleUnTrack = async (Id) => {
    try {
      await axios.post(
        `${getBaseUrl()}/UnTrackJockey`,
        { Jockey: Id },
        {
          headers: { Authorization: token, "x-xsrf-token": token },
        }
      );
      toast("Jockey Has Been UnTracked ");
      navigate("/tracker/#Jockeycontact1");
    } catch (error) {
      const err = error.response.data.message;
      toast(err);
    }
  };

  useEffect(() => {
    dispatch(fetchJockeyHistory({ id }));
    dispatch(fetchSinglejockey({ id }));
  }, [dispatch, id]);

  const cookiedata = Cookies.get("i18next");
  const token = Cookies.get("token");

  const handleTrack = async (Id) => {
    try {
      const res = await axios.post(
        `${getBaseUrl()}/TrackJockey`,
        { Jockey: Id },
        {
          headers: { Authorization: token, "x-xsrf-token": token },
        }
      );
      navigate("/tracker/#Jockeycontact1");
    } catch (error) {
      const err = error.response.data.message;
      if (err === "Json Web Token is invalid") {
        toast.error("Please Login to Access This Resource");
        navigate("/login");
      } else {
        toast.error(err);
      }
    }
  };

  function calculatePercentage(x, y) {
    if (x === 0 && y === 0) return 0;
    else {
      const answer = Math.round((x / y) * 100);
      return answer;
    }
  }

  function distanceLabel(distance, rank) {
    const DistanceTobeChecked = parseFloat(distance);
    if (DistanceTobeChecked.toFixed(2) > 25) {
      return "Dist";
    } else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) {
      return "SHd";
    } else if (DistanceTobeChecked.toFixed(2) == 0.10 && rank < 80) {
      return "Hd";
    } else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) {
      return "Nk";
    } else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) {
      return "Ns";
    } else if (DistanceTobeChecked.toFixed(2) == 0.00 && rank < 80) {
      if (rank === 1) {
        return 0;
      }
      return "Dh";
    } else {
      return distance;
    }
  }

  return (
    <div className="owner-new-master-wrapper">
      {status === "loading" ? (
        <Lottie animationData={Animate} loop={true} className="TableLottie" style={{ width: 150, margin: 'auto' }} />
      ) : (
        <div className="owner-new-page-content">
          
          {/* --- TOP SECTION: Profile Header --- */}
          <div className="owner-new-profile-header">
            <div className="owner-new-left-side">
              <div className="owner-new-img-box">
                <img
                  src={data.data?.JockeyOnRaceData1?.image || singlejockey.image || DefaultImg}
                  alt="Jockey"
                />
              </div>
              <div className="owner-new-info-content">
                {/* Column 1: Identity */}
                <div className="owner-new-main-details">
                  <h3 className="owner-new-name">
                    {cookiedata === "en"
                      ? singlejockey.NameEn || "- "
                      : singlejockey.NameAr || "- "}
                  </h3>
                  <p className="owner-new-stats-row">
                    {singlejockey.JockeyCount || 0} ({singlejockey.JockeyFirstRanking || 0}-{singlejockey.JockeySecondRanking || 0}-{singlejockey.JockeyThirdRanking || 0})
                  </p>
                </div>
              </div>
            </div>
            <div className="owner-new-right-side">
              {singlejockey.track === true ? (
                <button className="owner-new-btn-untrack" onClick={() => handleUnTrack(singlejockey._id)}>
                  {t("Untrack")}
                </button>
              ) : (
                <button className="owner-new-btn-track" onClick={() => handleTrack(singlejockey._id)}>
                  {t("Track")}
                </button>
              )}
            </div>
          </div>

          {/* --- MIDDLE SECTION: Lifetime Record Grid --- */}
          <div className="owner-new-middle-grid">
            <div className="owner-new-grid-thead">
              <div>{t("Lifetime Record")}</div>
              <div>{t("Runs")}</div>
              <div>{t("Wins")}</div>
              <div>{t("2nd")}</div>
              <div>{t("3rd")}</div>
              <div>{t("4th")}</div>
              <div>{t("5th")}</div>
              <div>{t("Winnings")}</div>
              <div>{t("Earnings")}</div>
            </div>
            <div className="owner-new-grid-tbody">
              {/* TURF Row */}
              <div className="owner-new-grid-row">
                <div className="new-bold">{t("TURF")}</div>
                <div>{singlejockey.TurfCount || 0}</div>
                <div>{singlejockey.TurfWins || 0}</div>
                <div>{singlejockey.Turfsecond || 0}</div>
                <div>{singlejockey.Turfthird || 0}</div>
                <div>{singlejockey.Turffourth || 0}</div>
                <div>{singlejockey.Turffifth || 0}</div>
                <div>
                  {calculatePercentage(
                    (singlejockey.Turfsecond || 0) + (singlejockey.TurfWins || 0) + (singlejockey.Turfthird || 0),
                    singlejockey.TurfCount || 0
                  )}%
                </div>
                <div>{Number(singlejockey.TurfEarnings || 0).toLocaleString()}</div>
              </div>
              {/* DIRT Row */}
              <div className="owner-new-grid-row">
                <div className="new-bold">{t("DIRT")}</div>
                <div>{singlejockey.DirtCount || 0}</div>
                <div>{singlejockey.DirtWins || 0}</div>
                <div>{singlejockey.Dirtsecond || 0}</div>
                <div>{singlejockey.Dirtthird || 0}</div>
                <div>{singlejockey.Dirtfourth || 0}</div>
                <div>{singlejockey.Dirtfifth || 0}</div>
                <div>
                  {calculatePercentage(
                    (singlejockey.Dirtsecond || 0) + (singlejockey.DirtWins || 0) + (singlejockey.Dirtthird || 0),
                    singlejockey.DirtCount || 0
                  )}%
                </div>
                <div>{Number(singlejockey.DirtEarnings || 0).toLocaleString()}</div>
              </div>
              {/* ALL WEATHER Row */}
              <div className="owner-new-grid-row">
                <div className="new-bold">{t("ALL WEATHER")}</div>
                <div>{singlejockey?.AllWeatherCount || 0}</div>
                <div>{singlejockey?.AllWeatherWins || 0}</div>
                <div>{singlejockey?.AllWeathersecond || 0}</div>
                <div>{singlejockey?.AllWeatherthird || 0}</div>
                <div>{singlejockey?.AllWeatherfourth || 0}</div>
                <div>{singlejockey?.AllWeatherfifth || 0}</div>
                <div>
                  {calculatePercentage(
                    (singlejockey?.AllWeathersecond || 0) + (singlejockey?.AllWeatherWins || 0) + (singlejockey?.AllWeatherthird || 0),
                    singlejockey?.AllWeatherCount || 0
                  )}%
                </div>
                <div>{Number(singlejockey?.AllWeatherEarnings || 0).toLocaleString()}</div>
              </div>
              {/* TOTAL Row */}
              <div className="owner-new-grid-row owner-new-total-highlight">
                <div className="new-bold">{t("TOTAL")}</div>
                <div>{singlejockey.TotalCount || 0}</div>
                <div>{singlejockey.TotalWins || 0}</div>
                <div>{singlejockey.Totalsecond || 0}</div>
                <div>{singlejockey.Totalthird || 0}</div>
                <div>{singlejockey.Totalfourth || 0}</div>
                <div>{singlejockey.Totalfifth || 0}</div>
                <div>
                  {calculatePercentage(
                    (singlejockey.Totalsecond || 0) + (singlejockey.TotalWins || 0) + (singlejockey.Totalthird || 0),
                    singlejockey.TotalCount || 0
                  )}%
                </div>
                <div>{Number(singlejockey.TotalEarnings || 0).toLocaleString()}</div>
              </div>
            </div>
          </div>

          {/* --- BOTTOM SECTION: Tabs & Details --- */}
          <div className="owner-new-tabs-container">
            <Tabs id="jockey-tabs" className="owner-new-styled-tabs mb-4" defaultActiveKey="Form">
              <Tab eventKey="Form" title={t("Form")}>
                <div className="owner-new-tab-content">
                  <ScrollContainer className="owner-new-scroll-box">
                    <div className="owner-new-16col-table">
                      <div className="owner-new-thead-16">
                        <div>{t("Date")}</div>
                        <div>{t("Crs")}</div>
                        <div>{t("Horse Name")}</div>
                        <div>{t("Dist")}</div>
                        <div>{t("RT")}</div>
                        <div>{t("Time")}</div>
                        <div>{t("Jockey")}</div>
                        <div>{t("Wgt")}</div>
                        <div>{t("Speed")}</div>
                        <div>{t("FP")}</div>
                        <div>{t("Len")}</div>
                        <div>{t("RN")}</div>
                        <div>{t("BtBy")}</div>
                        <div>{t("W Kgs")}</div>
                        <div>{t("Draw")}</div>
                        <div>{t("OR")}</div>
                        <div>{t("Link")}</div>
                      </div>
                      <div className="owner-new-tbody-16">
                        {(!SliceData || SliceData.length === 0) ? (
                          <div className="text-center py-4"><NoHistory /></div>
                        ) : (
                          SliceData.map((item, idx) => {
                            const ground = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                            const rowColor = ground === "Turf" ? "#d4edda" : ground === "Dirt" ? "#f2e6d9" : "#f1f5f9";
                            
                            return (
                              <div key={idx} className="owner-new-row-16" style={{ backgroundColor: rowColor, color: '#343433' }}>
                                <div onClick={() => handleShowRace(item.RaceID)} className="owner-new-link-white">
                                  <Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime}</Moment>
                                </div>
                                <div>
                                  {cookiedata === "en" 
                                    ? item.RaceResultData?.RaceCourseData?.AbbrevEn || "-"
                                    : item.RaceResultData?.RaceCourseData?.AbbrevAr || "-"
                                  } ({ground?.charAt(0)})
                                </div>
                                <div className="owner-new-link-white" onClick={() => handleShowHorse(item?.HorseIDData)}>
                                  {cookiedata === "en" ? toTitleCase(item?.HorseIDData?.NameEn || "-") : (item?.HorseIDData?.NameAr || "-")}
                                </div>
                                <div>{item.RaceResultData?.TrackLengthData?.TrackLength || "-"}</div>
                                <div className="owner-new-truncate">
                                  {cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}
                                </div>
                                <div>{item.RaceTime}</div>
                                <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult)} className="owner-new-link-white">
                                  {item.JockeyOnRaceDataResult 
                                    ? (cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult.ShortNameEn || item.JockeyOnRaceDataResult.NameEn) : item.JockeyOnRaceDataResult.ShortNameAr || item.JockeyOnRaceDataResult.NameAr)
                                    : "_"
                                  }
                                </div>
                                <div>{item.RaceResultData?.RacehorsesData ? item.RaceResultData?.RacehorsesData[0]?.JockeyRaceWeight : "0"}</div>
                                <div>{typeof item.Speed === "number" ? item.Speed.toFixed(2) : "-"}</div>
                                <div>{cookiedata === "en" ? item.FinalPositionDataHorse?.NameEn : item.FinalPositionDataHorse?.NameAr}</div>
                                <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                                <div>{item.RaceResultData?.Runners}</div>
                                {(() => {
                                  const rank = item?.FinalPositionDataHorse?.Rank;
                                  const targetHorse = rank === 1
                                    ? (item?.RunnerUpData || item?.BeatenByData || null)
                                    : (item?.WinnerData || item?.BeatenByData || null);
                                  const targetName = targetHorse
                                    ? (cookiedata === "en" ? toTitleCase(targetHorse.NameEn || "") : (targetHorse.NameAr || targetHorse.NameEn || "-"))
                                    : (cookiedata === "en"
                                        ? toTitleCase(item?.HorseIDData?.HorseBeatenByEnglishName || "")
                                        : (item?.HorseIDData?.HorseBeatenByArabicName || item?.HorseIDData?.HorseBeatenByEnglishName || "-"));
                                  const targetId = targetHorse?._id || item?.BeatenByData?._id;
                                  const targetWeight = targetHorse?.WinningHorseJockeyWeight ?? item?.BeatenByData?.WinningHorseJockeyWeight ?? item?.HorseIDData?.BeatenByJockeyWeight ?? 0;

                                  return (
                                    <>
                                      <div
                                        className={`owner-new-truncate ${targetId ? "owner-new-link-white" : ""}`}
                                        title={targetName || ""}
                                        onClick={() => targetId && handleShowHorse(targetId)}
                                        style={{ cursor: targetId ? "pointer" : "default" }}
                                      >
                                        {targetName || "-"}
                                      </div>
                                      <div>{targetWeight}</div>
                                    </>
                                  );
                                })()}
                                <div>{item.RaceResultData?.Draw || "-"}</div>
                                <div>{item.Rating || 0}</div>
                                <div onClick={() => handleShows(item.VideoLink)} className="owner-new-mini-play"><IoMdPlay /></div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </ScrollContainer>
                  <div className="owner-new-pagination-wrapper">
                    <Pagination
                      postsPerPage={postsPerPage}
                      totalPosts={totalcountdata}
                      paginate={paginate}
                      currentPage={currentPage}
                      TotalPages={totalpagesdata}
                    />
                  </div>
                </div>
              </Tab>
              <Tab eventKey="Entries" title={t("Entries")}>
                <JockeyEntries id={id} />
              </Tab>
              <Tab eventKey="Stats" title={t("Stats")}>
                <div className="RaceAndHorseModelDataCSS">
                  <Stats id={id} />
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      )}

      {/* --- ALL MODALS PRESERVED --- */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><VideoFrame data={modaldatas} /></Modal.Body>
      </Modal>
      <Modal show={ShowHorse} onHide={handleHorseCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><HorseModal data={modaldatasHorse} /></Modal.Body>
      </Modal>
      <Modal show={ShowJockey} onHide={handleJockeyCloses} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><JockeyDetail data={modaldatasJockey} /></Modal.Body>
      </Modal>
      <Modal show={showRace} onHide={handleCloseRace} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><RaceModal id={modaldataRace} /></Modal.Body>
      </Modal>
    </div>
  );
};

export default JockeyDetail;